import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";

// The entire admin section is lazy-loaded: its JavaScript lives in a SEPARATE
// chunk that the browser only downloads when someone actually visits /admin.
// Visitors to your public portfolio never download any of this code, so it has
// ZERO impact on your homepage load speed.
const AdminPanel = lazy(() => import("./admin/AdminPanel"));

const App = () => {
  return (
    <Routes>
      {/* Public portfolio */}
      <Route path="/" element={<Home />} />

      {/* Private admin panel — code-split, loaded on demand */}
      <Route
        path="/admin/*"
        element={
          <Suspense fallback={<div style={{ padding: 40 }}>Loading…</div>}>
            <AdminPanel />
          </Suspense>
        }
      />
    </Routes>
  );
};

export default App;
